import { useMount } from 'react-use';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import { GuardianPesel } from '@dreryk/personal-external-identifier-common-api';

import { FormContextValues } from '@dreryk/react-common';

import { PersonalDataFormBean } from '../common.types';
import { createGuardianExternalIdentifier } from '../GuardianModal/GuardianDetailsModal/GuardianDetailsModal';
import { GuardianModal } from '../GuardianModal/GuardianModal';
import { GuardianModalFormBean } from '../GuardianModal/GuardianModal.types';

import { getDefaultPatientIdentifierType } from './PatientIdentifierTypeField/PatientIdentifierTypeField';

type GuardianModalProps = {
   readonly setValue: FormContextValues<PersonalDataFormBean>['setValue'];
   readonly onClose: VoidFunction;
   readonly patientId?: Patient['id'];
};

export const PersonFormGuardianModal = (props: GuardianModalProps): JSX.Element => {
   const handleClose = (): void => {
      props.setValue('personalIdentifierType', getDefaultPatientIdentifierType());
      props.onClose();
   };

   const setFormState = (guardianModalFormData: GuardianModalFormBean): void => {
      const guardian = guardianModalFormData.guardian!;
      const guardianExternalIdentifier = createGuardianExternalIdentifier(guardian);

      props.setValue(
         'guardianPesel',
         guardianExternalIdentifier.accept<GuardianPesel | null>({
            visitPesel: (pesel) => GuardianPesel.of(pesel.asString()),
            visitPassport: () => null,
            visitNationalIdentificationNumber: () => null,
         })
      );
      props.setValue('identifyingGuardian', guardianModalFormData);
      props.onClose();
   };

   useMount(() => {
      props.setValue('identifyingGuardian', undefined);
   });

   return (
      <GuardianModal
         patientId={props.patientId}
         patientPesel={null}
         onClose={handleClose}
         onSubmit={setFormState}
         statutoryRepresentative
         isIdentifyingGuardian
      />
   );
};
